import { connect } from 'react-redux';
import { add, update, get} from '../../modules/inventory/fuelMaintenanceCost';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state) => {
	/*
	const fuelMaintenanceCostId = _.get(ownProps, ['match', 'params', 'fuelMaintenanceCostId']);
	const fuelMaintenanceCost = (fuelMaintenanceCostId)
		? _.get(state.maps, ['fuelMaintenanceCost', fuelMaintenanceCostId])
		: undefined;
	 */

	return {
		// fuelMaintenanceCost,
		userMap : state.maps.user,
		supplierMap : state.maps.supplier,
		terminalMap : state.maps.terminal,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	addFuelMaintenanceCost : add,
	updateFuelMaintenanceCost : update,
	getFuelMaintenanceCost : get,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
